// A number that goes up and down by one: the quantity of a bottle. Both buttons are IconButtons, so
// the target, focus ring and press feedback are the kit's.
import "./config";
import { IconButton } from "./controls";
import { Icon } from "./Icon";
import { Row } from "./layout";
import { Body } from "./text";

export interface StepperProps {
  value: number;
  onDecrement: () => void;
  onIncrement: () => void;
  /** The names of the two buttons; the glyphs alone say nothing to a screen reader. */
  decreaseLabel?: string;
  increaseLabel?: string;
}

export function Stepper({
  value,
  onDecrement,
  onIncrement,
  decreaseLabel = "−",
  increaseLabel = "+",
}: StepperProps): React.JSX.Element {
  return (
    <Row gap="2">
      <IconButton aria-label={decreaseLabel} onPress={onDecrement}>
        <Icon name="minus" size={18} />
      </IconButton>
      <Body weight="strong" numeric center minWidth={28}>
        {value}
      </Body>
      <IconButton aria-label={increaseLabel} onPress={onIncrement}>
        <Icon name="plus" size={18} />
      </IconButton>
    </Row>
  );
}
